import { datadogRum, type RumInitConfiguration } from '@datadog/browser-rum';
import type { User } from './types';

export function initRum(config: RumInitConfiguration) {
  datadogRum.init(config);
}

export function startSessionReplayRecording(): void {
  datadogRum.startSessionReplayRecording();
}

export function stopSessionReplayRecording(): void {
  datadogRum.stopSessionReplayRecording();
}

export function addRumAction(actionName: string, context?: object) {
  datadogRum.addAction(actionName, context);
}

export function setRumUser(user: User) {
  datadogRum.setUser(user);
}

export function addRumGlobalContext(context) {
  datadogRum.setGlobalContext(context);
}

export function removeRumGlobalContext() {
  datadogRum.clearGlobalContext();
}

export function setRumGlobalContextProperty(key: string, value: any): void {
  datadogRum.setGlobalContextProperty(key, value);
}

export function removeRumGlobalContextProperty(key: string): void {
  datadogRum.removeGlobalContextProperty(key);
}

export function startRumView(name: string) {
  datadogRum.startView(name);
}

export function startDurationVital(
  name: string,
  options?: {
    context?: object;
    description?: string;
  }
) {
  datadogRum.startDurationVital(name, options);
}

export function addDurationVital(
  name: string,
  options: {
    startTime: number;
    duration: number;
    context?: object;
    description?: string;
  }
) {
  datadogRum.addDurationVital(name, options);
}

export const formatViewName = (pathname: string) => {
  if (pathname === '/') {
    return 'home';
  }

  const pathParts = pathname
    .split('/')
    // if the part contains numbers, it's an ID and we are removing it
    .filter((part) => part !== '' && part !== 'undefined' && !/\d/.test(part));

  if (!pathParts.length) {
    return 'home';
  }

  return pathParts.join('/');
};
